
export default {
  props: {
    to: String,
    text: { default: "حذف", type: String },
    color: { default: "danger", type: String },
  },
};
